"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function EditLocationEvent(locationName, clientIdRef, clientSecretRef) {
    //return new VeriLiteInformationEvent(
    //    <div>
    //        <InputGroup className="my-3" >
    //            <InputGroupAddon addonType="prepend" >
    //                <InputGroupText>Client Id </InputGroupText>
    //            </InputGroupAddon>
    //            <Input innerRef={clientIdRef} />
    //        </InputGroup>
    //        <InputGroup className="my-3" >
    //            <InputGroupAddon addonType="prepend" >
    //                <InputGroupText>Client Secret </InputGroupText>
    //            </InputGroupAddon>
    //            <Input innerRef={clientSecretRef} />
    //        </InputGroup>
    //    </div>,
    //    `Edit ${locationName}`,
    //    [
    //        {
    //            text: "test",
    //            callback: (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
    //                //console.log(`Id: ${clientIdRef.current?.value}`);
    //                //console.log(`Secret: ${clientSecretRef.current?.value}`);
    //            },
    //            color: "primary"
    //        }, {
    //            text: "close",
    //            callback: (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
    //                closeModalCallback();
    //            },
    //            color: "secondary"
    //        }
    //    ]
    //);
}
exports.EditLocationEvent = EditLocationEvent;
//# sourceMappingURL=EditLocationEvent.js.map